import '@ant-design/v5-patch-for-react-19'
import { message } from 'antd'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import App from './App.jsx'
import './index.css'

// Ensure message renders to body and stays on top
message.config({ getContainer: () => document.body, top: 16 });

createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
)
